'use client'

import CommentTextarea from '@/app/[locale]/[roomId]/components/CommentTextarea'
import ViverseAvatar from '@/components/ViverseAvatar'
import { COMMENT_MAXIMUM_CHARACTERS } from '@/constants/comment'
import { useConfigsContext } from '@/context/ConfigsContext'
import { cn } from '@/lib/utils'
import { useState } from 'react'
import { useIsClient, useMediaQuery } from 'usehooks-ts'

function AddCommentField({ addComment }: { addComment: (value: string) => Promise<void> }) {
  const [value, setValue] = useState('')
  const { store } = useConfigsContext()
  const isTablet = useMediaQuery('(min-width: 768px)')
  const isClient = useIsClient()
  const [isLoading, setIsLoading] = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value)
  }

  const handleAdd = async () => {
    setIsLoading(true)
    await addComment(value)
    setValue('')
    setIsLoading(false)
  }
  return (
    <div
      className={cn(
        'flex min-h-[34px] justify-between gap-2 align-middle md:min-h-[48px] md:gap-4',
      )}
    >
      <ViverseAvatar
        size={isClient && isTablet ? 'M' : 'S'}
        imageUrl={isClient ? store?.profile?.avatarSnapshot : ''}
      />
      <CommentTextarea
        textAreaElementId="add-comment"
        value={value}
        submitButtonSize={isClient && isTablet ? 'M' : 'S'}
        containerClassName={cn('md:min-h-[48px] md:gap-4')}
        className="md:px-5 md:py-3"
        onChange={handleChange}
        onSubmit={handleAdd}
        maxLength={COMMENT_MAXIMUM_CHARACTERS}
        disabled={isLoading}
      />
    </div>
  )
}

export default AddCommentField
